var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      attrs: {
        show: _vm.bigLoading,
        rounded: "sm",
        "spinner-variant": "warning"
      },
      scopedSlots: _vm._u([
        {
          key: "overlay",
          fn: function() {
            return [
              _c("b-icon", {
                attrs: {
                  icon: "three-dots",
                  animation: "cylon",
                  scale: "8",
                  variant: "warning"
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isError
        ? _c(
            "div",
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  items: _vm.data,
                  fields: _vm.fields
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell()",
                      fn: function(data) {
                        return [
                          _c("span", {
                            staticClass: "table-span",
                            domProps: { innerHTML: _vm._s(data.value) }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3701882303
                )
              })
            ],
            1
          )
        : _c("div", { staticClass: "error-box" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("dashboard.isError")))])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fef87b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fef87b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Grid.vue
// module id = null
// module chunks = 